class AbstractPathService {
  todo() {
  }
}

export default AbstractPathService;



// WEBPACK FOOTER //
// ./src/data/AbstractPathService.js